import { followingSidebar } from '../utils/sidebar.utils.js';

const sideBarSec = document.querySelector('.job-descr');

if (sideBarSec) {
  const sidebar = document.querySelector('#sidebar');
  const contentSticky = document.querySelector('#content-sticky');


  if (sidebar && window.innerWidth >= 731) {
    followingSidebar({ sidebar, contentSticky });
  }
}



